__turbopack_context__.v({
  "radio": "RadioInput-module-scss-module__4eufyW__radio",
  "radio__input": "RadioInput-module-scss-module__4eufyW__radio__input",
  "radio__label": "RadioInput-module-scss-module__4eufyW__radio__label",
});
